<template>
  <svg
    style="fill: currentColor"
    viewBox="0,0,24,24"
    :width="size"
    :height="size"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.385 4.6a.63.63 0 00-.631.63v.71l-.437.123c-.466.132-.91.317-1.325.55l-.396.22-.501-.5a.63.63 0 00-.892 0l-.87.87a.63.63 0 000 .892l.5.501-.22.396a6.128 6.128 0 00-.55 1.325l-.124.437h-.708a.63.63 0 00-.631.63v1.231c0 .349.282.631.63.631h.71l.123.437c.132.466.317.91.55 1.325l.22.396-.5.501a.63.63 0 000 .893l.87.87a.63.63 0 00.892 0l.501-.502.396.222c.415.232.859.417 1.325.55l.437.123v.708c0 .349.282.631.63.631h1.231a.63.63 0 00.631-.63v-.71l.437-.123c.466-.132.91-.317 1.325-.55l.396-.22.501.5a.63.63 0 00.893 0l.87-.87a.63.63 0 000-.892l-.502-.501.222-.396c.232-.415.417-.859.55-1.325l.123-.437h.708a.63.63 0 00.631-.63v-1.231a.63.63 0 00-.63-.631h-.71l-.123-.437a6.132 6.132 0 00-.55-1.325l-.22-.396.5-.501a.63.63 0 000-.892l-.87-.87a.63.63 0 00-.892 0l-.501.5-.396-.22a6.128 6.128 0 00-1.325-.55l-.437-.124v-.708a.63.63 0 00-.63-.631h-1.231zm-1.822.443A1.831 1.831 0 0111.385 3.4h1.23c.948 0 1.728.72 1.822 1.643.26.091.513.197.759.315a1.831 1.831 0 012.45.126l.87.87c.67.67.713 1.731.126 2.45.118.246.224.5.315.76a1.83 1.83 0 011.643 1.82v1.231c0 .948-.72 1.728-1.643 1.822a7.32 7.32 0 01-.315.759 1.83 1.83 0 01-.126 2.45l-.87.87a1.83 1.83 0 01-2.45.126 7.32 7.32 0 01-.76.315 1.831 1.831 0 01-1.82 1.643h-1.231a1.83 1.83 0 01-1.822-1.643 7.32 7.32 0 01-.759-.315 1.83 1.83 0 01-2.45-.126l-.87-.87a1.831 1.831 0 01-.126-2.45 7.325 7.325 0 01-.315-.76 1.831 1.831 0 01-1.643-1.82v-1.231c0-.948.72-1.728 1.643-1.822.091-.26.197-.513.315-.759a1.831 1.831 0 01.126-2.45l.87-.87a1.831 1.831 0 012.45-.126c.246-.118.5-.224.76-.315z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.938 12a3.062 3.062 0 116.124 0 3.062 3.062 0 01-6.124 0zM12 10.139a1.861 1.861 0 100 3.722 1.861 1.861 0 000-3.723z"
    />
  </svg>
</template>

<script>
export default {
  name: 'TestIcon',
  props: {
    size: {
      type: String,
      default: '18',
    },
  },
}
</script>
